import { VACANCE } from "@helpers/_constants";

function getLabelRemaining(congeUsed, congeRemaining) {
  if (parseFloat(congeUsed) < 0) {
    return congeRemaining;
  }

  return parseFloat(congeUsed) + parseFloat(congeRemaining);
}

/** @type {Chart.ChartOptions} */
export const graphOptions = {
  tooltips: {
    bodyFontSize: 15,
    caretSize: 8,
    titleFontSize: 13,

    callbacks: {
      label: (tooltipItem, data) => {
        const index = tooltipItem.index;
        switch (tooltipItem.datasetIndex) {
          case 0:
          case 1: {
            return (
              data.datasets[0].data[index] +
              " / " +
              getLabelRemaining(
                data.datasets[0].data[index],
                data.datasets[1].data[index],
              )
            );
          }

          case 2:
          case 3: {
            return (
              data.datasets[2].data[index] +
              " / " +
              getLabelRemaining(
                data.datasets[2].data[index],
                data.datasets[3].data[index],
              )
            );
          }

          case 4:
          case 5: {
            return (
              data.datasets[4].data[index] +
              " / " +
              getLabelRemaining(
                data.datasets[4].data[index],
                data.datasets[5].data[index],
              )
            );
          }

          default:
            return "0";
        }
      },
    },
  },
  legend: {
    display: false,
  },
  scales: {
    yAxes: [
      {
        ticks: {
          precision: 0,
        },
      },
    ],
    xAxes: [
      {
        stacked: true,
      },
    ],
  },
};

export const graphPlugins = [
  {
    beforeRender: function (chart) {
      let datasets = chart.config.data.datasets;

      for (let [index, chartdataset] of datasets.entries()) {
        if (![1, 3, 5].includes(index)) {
          continue;
        }

        for (let [i, chartValue] of chartdataset.data.entries()) {
          if (parseFloat(chartValue) < 0) {
            try {
              chartdataset._meta[chart.id].data[i]._model.height = 0;
              chartdataset._meta[chart.id].data[i]._model.base =
                chartdataset._meta[chart.id].data[i]._model.y;
            } catch (error) {
              console.error(error);
            }
          }
        }
      }
    },
  },
];

export function getUsedHolidays(employeHolidays, category, holidayList) {
  const isUnlimited = holidayList?.find(
    (hol) => hol._id === category || hol.category === category
  )?.unlimitedBalance;
  if (category === VACANCE && /*employeHolidays[category].hoursIllimited*/ isUnlimited) {
    return 0;
  }

  const output =
    parseFloat(employeHolidays[category].total) -
    parseFloat(employeHolidays[category].remaining);

  return output?.toFixed(2) || 0;
}

export function getRemainingHolidays(employeHolidays, category, holidayList) {
  const isUnlimited = holidayList?.find(
    (hol) => hol._id === category || hol.category === category
  )?.unlimitedBalance;
  if (category === VACANCE && /*employeHolidays[category].hoursIllimited*/ isUnlimited) {
    return 0;
  }

  const remaining = parseFloat(employeHolidays[category].remaining);
  const total = parseFloat(employeHolidays[category].total);
  const output = Math.min(remaining, total);

  return output?.toFixed(2) || 0;
}
